import _ from "lodash"

export const deleteSearchParams = (url: URL, paramsToClear: string[]): string => {
  _.forEach(paramsToClear, param => url.searchParams.delete(param))
  return url.toString()
}
